import { format, parseISO, addMinutes, subDays, startOfWeek, endOfWeek } from 'date-fns';
import { fetchOldestRecordTime } from './loaders/oldestRecordTimeApi';
import { getFilterParamsFromLocalStorage } from './localStorageUtils';

export const formatToUtc = (isoDateString) => {
  const date = parseISO(isoDateString);
  const utcDate = addMinutes(date, date.getTimezoneOffset());

  return format(utcDate, "dd/MM/yyyy, HH:mm:ss");
};

export const applyDateRange = ({ selectedRange, filterValues, setFilters, setShowCalendar }) => {
  const selection = selectedRange[0];

  setFilters({
    ...filterValues,
    start_date: selection.startDate ? format(selection.startDate, 'yyyy-MM-dd') : '',
    end_date: selection.endDate ? format(selection.endDate, 'yyyy-MM-dd') : new Date(),
  });

  setShowCalendar(false);
};

export const formatDateRange = (date) => {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return '';
  }

  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const createCustomStaticRanges = (firstRecordTime) => [
  {
    label: 'All Time',
    range: () => ({
      startDate: firstRecordTime ? new Date(firstRecordTime) : '',
      endDate: new Date(),
    }),
  },
];

export const getDefaultDateRange = () => {
  const today = new Date();
  const lastWeekStart =subDays(today, 7);
  const lastWeekEnd = today;
  
  return {
    startDate: lastWeekStart,
    endDate: lastWeekEnd,
  };
};

export const getInitialListDateRange = ({ localStorageKey }) => {
  const { startDate, endDate } = getFilterParamsFromLocalStorage(localStorageKey);
  
  if (!startDate && !endDate) {
    return getDefaultDateRange();
  }
  
  return {
    startDate: startDate || null,
    endDate: endDate || null,
  };
};

export const loadInitialDates = async ({ localStorageKey, endpoint }) => {
  const { startDate, endDate } = getFilterParamsFromLocalStorage(localStorageKey);
  const oldestRecordTime = await fetchOldestRecordTime(endpoint);

  // Check if this is a meta_api_data component and no saved dates exist
  const isMetaApiData = localStorageKey === 'meta_api_data' || localStorageKey === 'meta_api_data/aggregated-pixel';
  const hasNoSavedDates = !startDate && !endDate;

  let dateRange;
  if (isMetaApiData && hasNoSavedDates) {
    dateRange = getDefaultDateRange();
  } else {
    dateRange = {
      startDate: startDate || oldestRecordTime,
      endDate: endDate || new Date(),
    };
  }

  return {
    dateRange,
    firstRecordTime: oldestRecordTime,
  };
};
